export class Newsletter {
    constructor() {
        this.setProperties();
        this.setEvents();
    }

    setProperties () {
        this.$overlay = $( '.newsletter-overlay' );
        this.$triggerForm = $( '#newsletter-trigger' );
        this.$form = $( '#newsletter-form' );
        this.$mailInput = this.$triggerForm.find( 'input[type="email"]' );
        this.$modalMailInput = this.$overlay.find( '#newsletter-modal-email' );
        this.$close = this.$overlay.find( '.newsletter-close' );
        this.$alert = this.$overlay.find( '.newsletter-alert' );
        this.$emailAlert = this.$overlay.find( '.newsletter-email-alert' );
        this.$checkboxesContainer = this.$overlay.find( '.newsletter-checkboxes' );
    }

    setEvents () {
        this.$triggerForm.on( 'submit', ( event ) => {
            event.preventDefault();

            this.$modalMailInput.val( this.$mailInput.val() );
            this.$overlay.addClass( 'active' );
        } );

        this.$close.on( 'click', () => {
            this.$overlay.removeClass( 'active' );
        } );

        this.$form.on( 'submit', ( event ) => {
            if ( '' === this.$modalMailInput.val() ) {
                event.preventDefault();
                this.$emailAlert.addClass( 'active' );

                return;
            } else {
                this.$emailAlert.removeClass( 'active' );
            }

            if ( 0 === this.$checkboxesContainer.find( 'input:not(:checked)' ).length ) {
                this.$alert.removeClass( 'active' );
            } else {
                event.preventDefault();
                this.$alert.addClass( 'active' );
            }
        } );
    }
}
